import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the provider to confirm. */
const providerToDeleteSignal = createSignal<number | null>(null);

export const setProviderToDelete = (providerId: number | null): void => {
	providerToDeleteSignal.value = providerId;
};

export default providerToDeleteSignal;
